export var FeedbackFrequency;
(function (FeedbackFrequency) {
    FeedbackFrequency[FeedbackFrequency["RIGHT_NOW"] = 1] = "RIGHT_NOW";
    FeedbackFrequency[FeedbackFrequency["DAY"] = 2] = "DAY";
})(FeedbackFrequency || (FeedbackFrequency = {}));
//# sourceMappingURL=FeedbackFrequency.js.map